"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartingaleShareProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const utils_1 = require("../../TradeUtils/Share/utils");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 * 处理订单分享及跟单
 */
var MartingaleShareProcessor;
(function (MartingaleShareProcessor) {
    /** 分享卡片信息 */
    function useShareCardInfo({ exchangeOrder, shareData, $st, dateFormatter, tickerMap, useSymbolPrice, }) {
        var _a, _b, _c, _d, _e;
        const innerOrder = exchangeOrder && TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
        const isMulti = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.isMulti;
        const quote = (_a = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.quote) !== null && _a !== void 0 ? _a : "USDT";
        const createTime = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.triggerTime) && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.triggerTime) > 0 ? innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.triggerTime : exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp;
        const coins = (0, react_1.useMemo)(() => {
            if (!(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.coins)) {
                return [];
            }
            return innerOrder.coins.map((item) => {
                var _a;
                return Object.assign(Object.assign({}, item), { 
                    // 当前的实时总价值
                    totalValue: new trade_utils_lib_1.SafeDecimal(item.currentBaseAmount).mul(new trade_utils_lib_1.SafeDecimal((_a = tickerMap.get(`${item.base}/${quote}`)) !== null && _a !== void 0 ? _a : 0)) });
            });
        }, [innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.coins, quote, tickerMap]);
        const title = (0, react_1.useMemo)(() => {
            var _a, _b;
            if (shareData === null || shareData === void 0 ? void 0 : shareData.customize_name) {
                return shareData === null || shareData === void 0 ? void 0 : shareData.customize_name;
            }
            return coins.length === 0
                ? ""
                : isMulti
                    ? $st("mtg_share_title_mutiple", { name: (_a = shareData === null || shareData === void 0 ? void 0 : shareData.nick_name) !== null && _a !== void 0 ? _a : "" })
                    : $st("mtg_share_title_single", { name: (_b = shareData === null || shareData === void 0 ? void 0 : shareData.nick_name) !== null && _b !== void 0 ? _b : "" });
        }, [shareData === null || shareData === void 0 ? void 0 : shareData.customize_name, shareData === null || shareData === void 0 ? void 0 : shareData.nick_name, coins.length, isMulti, $st]);
        const subTitle = (0, react_1.useMemo)(() => {
            const tmpCoins = [...coins];
            tmpCoins.sort((a, b) => (a.totalValue.gt(b.totalValue) ? 1 : -1));
            const maxValueCoins = tmpCoins.map((item) => item.baseDisplay);
            if (coins.length === 0) {
                return "";
            }
            if (!isMulti) {
                return `${coins[0].base}/${quote}`;
            }
            if (coins.length <= 2) {
                return $st("mtg_share_sub_title_double", { coin: maxValueCoins.slice(0, 2).join("、") });
            }
            return $st("mtg_share_sub_title", { coin: maxValueCoins.slice(0, 2).join("、"), num: coins === null || coins === void 0 ? void 0 : coins.length });
        }, [$st, coins, isMulti, quote]);
        const totalRoundCount = (0, react_1.useMemo)(() => {
            let cnt = 0;
            innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.coins.forEach((item) => {
                cnt = cnt + item.roundCount;
            });
            return cnt;
        }, [innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.coins]);
        const baseCoin = !isMulti ? innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.coins[0].base : "BTC";
        // 开单时基准币价格
        const { value: openBasePrice } = useSymbolPrice(baseCoin !== null && baseCoin !== void 0 ? baseCoin : "", isMulti ? "USDT" : quote, (_b = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp) !== null && _b !== void 0 ? _b : 0);
        // 当前基准币价格
        const currentBasePrice = (_c = tickerMap.get(`${baseCoin}/${isMulti ? "USDT" : quote}`)) !== null && _c !== void 0 ? _c : "--";
        const orderTriggerTime = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.triggerTime) && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.triggerTime) > 0 ? innerOrder.triggerTime : exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp;
        return {
            title: title,
            subTitle: subTitle,
            marketInfo: {
                openBasePrice: !isMulti
                    ? {
                        key: "mtg_share_card_items_open_price",
                        label: $st("mtg_share_card_items_open_price"),
                        value: (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.isConditionAndNotTriggered)
                            ? $st("grid_hedge_futures_not_triggered")
                            : openBasePrice
                                ? `${openBasePrice} ${quote}`
                                : "--",
                    }
                    : {
                        key: "mtg_share_open_btc_price",
                        label: $st("mtg_share_open_btc_price"),
                        value: (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.isConditionAndNotTriggered)
                            ? $st("grid_hedge_futures_not_triggered")
                            : openBasePrice
                                ? `${openBasePrice} USDT`
                                : "--",
                    },
                currentBasePrice: !isMulti
                    ? {
                        key: "mtg_share_card_items_current_price",
                        label: $st("mtg_share_card_items_current_price"),
                        value: currentBasePrice ? `${currentBasePrice} ${quote}` : "--",
                    }
                    : {
                        key: "mtg_share_current_btc_price",
                        label: $st("mtg_share_current_btc_price"),
                        value: currentBasePrice ? `${currentBasePrice} USDT` : "--",
                    },
                orderTriggerTime: {
                    label: $st("mtg_share_open_time"),
                    timeStamp: orderTriggerTime,
                    value: !orderTriggerTime ? "--" : (_d = dateFormatter === null || dateFormatter === void 0 ? void 0 : dateFormatter.format) === null || _d === void 0 ? void 0 : _d.call(dateFormatter, orderTriggerTime, "YYYY/MM/DD HH:mm"),
                },
            },
            runningTime: {
                label: $st("mtg_share_total_round_count"),
                value: (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.isConditionAndNotTriggered)
                    ? "0"
                    : (0, utils_1.getLastDesc)({
                        createTime: createTime !== null && createTime !== void 0 ? createTime : new Date().getTime(),
                        closeTime: (exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.closeTimestamp) && (exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.closeTimestamp) > 0
                            ? exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.closeTimestamp
                            : undefined,
                        $st,
                    }),
            },
            totalRoundCount: {
                label: $st("mtg_share_total_round_count"),
                value: totalRoundCount,
            },
            orderCreateTime: {
                label: $st("mtg_share_open_time"),
                timeStamp: exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp,
                value: !(exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp) ? "--" : (_e = dateFormatter === null || dateFormatter === void 0 ? void 0 : dateFormatter.format) === null || _e === void 0 ? void 0 : _e.call(dateFormatter, exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp, "YYYY/MM/DD HH:mm"),
            },
        };
    }
    MartingaleShareProcessor.useShareCardInfo = useShareCardInfo;
})(MartingaleShareProcessor || (exports.MartingaleShareProcessor = MartingaleShareProcessor = {}));
